module.exports = __webpack_public_path__ + "static/img/biao2.f45a973.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/biao2.png
// module id = PZnI
// module chunks = 0